module.exports = __webpack_public_path__ + "img/info_sp_23.fdc6c624.png";